import { Hotjar } from '@sennder/shell-utilities'

import {
  identifyUserInAnalytics,
  initAnalytics,
  resetAnalyticsSession,
  stopAnalytics,
} from './analytics'
import { HOTJAR_ID, isProductionEnv } from '@/common/config'

import { logger } from '@/services/logger/loggers'
import { identifyUserInLogger, initLogger, stopLogger } from '@/services/logger'
import {
  identifyUserInMonitor,
  initMonitor,
  stopMonitor,
} from '@/services/monitor'
import { getStateData, getUserProfile } from '@/store'
import { startUserlane } from '@/services/Userlane'
import { getFeatureFlags } from '@sennder/senn-node-feature-flags-frontend'

let state: 'stopped' | 'started' = 'stopped'

export function startTracking() {
  if (state === 'started') {
    return
  }

  initLogger()
  initMonitor()
  initAnalytics()

  if (isProductionEnv() && HOTJAR_ID) {
    const hotjar = new Hotjar(console, HOTJAR_ID)
    // This is an async func, but we don't want to wait for startTracking since it would block the entire page rendering
    hotjar.inject()
  }

  state = 'started'

  log('tracking has started')
}

export function identifyUserInTracking(onLogin = false) {
  if (state === 'stopped') {
    return
  }
  const profile = getUserProfile()

  identifyUserInAnalytics(onLogin)

  const { id, email } = profile

  identifyUserInLogger(id, email)
  identifyUserInMonitor(id, email)

  if (getFeatureFlags()['ENABLE_USERLANE']) {
    startUserlane(
      id,
      getStateData().roles.map((role) => role.name)
    )
  }

  log('user is identified')
}

export function anonymizeTracking() {
  if (state === 'stopped') {
    return
  }
  resetAnalyticsSession()

  log('user is anonymized')
}

export function stopTracking() {
  stopAnalytics()
  stopMonitor()
  stopLogger()
  state = 'stopped'

  log('tracking has stopped')
}

function log(message: string) {
  const prefix = '[tracking]'
  logger.info(`${prefix} ${message}`, {})
  console.log(`${prefix} ${message}`)
}
